import Request from 'core/api/Request';
import { getter } from 'core/utils/request';

export const post = async (url, data = {}) => {
  const response = await Request.post(url).send(data);
  return response.body;
};

export const fetchAndCreateIfMissing = (defaultPostData) => async (url) => {
  try {
    const data = await getter(url);
    return data;
  } catch (e) {
    if (e.status === 404) {
      return post(url, defaultPostData);
    }
    throw e;
  }
};

export const patch = async (url, data = {}) => {
  const response = await Request.patch(url).send(data);
  return response.body;
};
